/** @jsx jsx */
import { jsx } from "theme-ui";

function NavIcon() {
  return (
    <svg viewBox="0 0 100 80" width="32" height="32">
      <rect width="100" height="4"></rect>
      <rect y="30" width="100" height="4"></rect>
      <rect y="60" width="100" height="4"></rect>
    </svg>
  );
}

export default NavIcon;
